import React, { PureComponent } from 'react';

import glyphs from 'app/constants/glyphs';
import routeDetails from 'app/constants/routeDetails';

import pageLock from 'app/utils/pageLock';

import Icon from 'app/components/Icon';
import Link from 'app/components/Link';

import Nav from './Nav';

import styles from './styles.css';

class Header extends PureComponent {
  state = {
    isOpen: false,
  };

  handleNavOnClick = () => {
    const { isOpen } = this.state;

    this.setState(
      {
        isOpen: !isOpen,
      },
      () => pageLock(!isOpen)
    );
  };

  handleLogoOnClick = () => {
    this.setState(
      {
        isOpen: false,
      },
      () => pageLock(false)
    );
  };

  render() {
    const { isOpen } = this.state;

    return (
      <div className={styles.container}>
        <div className={styles.grid}>
          <Link
            className={styles.logo}
            to={routeDetails.HOME.url}
            onClick={this.handleLogoOnClick}
          >
            <Icon icon={glyphs.LOGO} title={'Prick Predictor'} />
          </Link>
          <Nav isOpen={isOpen} onNavClick={this.handleNavOnClick} />
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js